import React from 'react';
import './Mazar.css';
import { Link } from 'react-router-dom';



const Mazar = () => {
    return (
        <div className="card-container">
            <Link style={{ color: 'inherit', textDecoration: 'none' }} to="https://tour.soleimani.ir/">
                <div className="mazar-image"></div>
                {/* <div className="CompetitionCard-content"></div> */}
            </Link>
        </div>
    );
};

export default Mazar;
